import cx from "classnames";
import { useAtom } from "jotai/index";
import { canv } from "@/canv/global";
import { mindMapToolMenuActivePresetAtom } from "@/interface/AppStore";
import { MIDNMAP_LIST_DATA } from "@/interface/SideBar/MindMapMenu/constants";
import styles from "./MindMapMenu.module.css";

export const MindMapMenu = () => {
    const [preset, setPreset] = useAtom(mindMapToolMenuActivePresetAtom);
    return (
        <div className={styles.mindMapToolWindow}>
            <div className={styles.mindMapToolWindowContent}>
                <div className={styles.mindMapToolWindowContentTop}>
                    <div className={styles.mindMapToolWindowContentTopLeft}>
                        <div className={styles.mindMapToolWindowContentTopLeftTitle}>
                            Майнд карты
                        </div>
                        <div className={styles.mindMapToolWindowContentTopLeftDesc}>
                            Создавайте визуальные связи между концепциями и идеями
                        </div>
                    </div>
                </div>
                <div className={styles.mindMapToolWindowContentOptions}>
                    {MIDNMAP_LIST_DATA.map((map) => (
                        <div
                            key={map.code}
                            className={cx(
                                styles.mindMapToolWindowContentOptionsItem,
                                map.code === preset &&
                                    styles.mindMapToolWindowContentOptionsItemSelected,
                            )}
                            onClick={() => {
                                canv.toolBox.TryGetToolByName("mindMapTool").setPreset(map.code);
                                setPreset(map.code);
                            }}
                        >
                            <img src={map.imgSrc} alt={map.code} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
